module.exports = __webpack_public_path__ + "static/media/incoming-video-call.4ee92e3d.svg";